import loadable from "@loadable/component";
import React from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

const MaintananceComponent = loadable(
  () => import("../Components/Maintanance")
);
const Maintanance = () => {
  return (
    <>
      <div className={tw`flex h-[100vh] overflow-y-auto `}>
        <div className={tw`h-full w-full`}>
          <div
            className={tw`bg-primary-light w-full h-36 text-primary text-2xl flex items-center justify-center font-bold`}
          >
            Maintanance Break !
          </div>
          <MaintananceComponent />
          <div className={tw`mx-16`}>
            <p>
              Need Assistance?
              <br />
              If you have any urgent inquiries or need support during this
              period, please contact us at:
            </p>
            <p className={tw`text-primary`}>Phone no:+977-</p>
            <p className={tw`text-primary`}>Email:Support@careinfo.com</p>
            <p>Thank you for your patience and understanding.</p>
          </div>
          <div
            className={tw`h-[30px] w-full text-gray-700 flex items-center text-white  bg-primary p-2 justify-center  mt-4`}
          >
            <h1>Copyright ©2024 Careinfo Solutions</h1>
          </div>
        </div>
      </div>
    </>
  );
};

export default Maintanance;
